module.exports = __webpack_public_path__ + "static/media/segmento-varejo.5bf68439.gif";